// For now only checks if user browser if Safari
export function getUserBrowser() {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf("Safari") && userAgent.indexOf("Chrome") === -1) {
    return "Safari";
  }
  return null;
}